import { RootState } from '..';

export function getShowThankYouModal(state: RootState): boolean {
  return state.dashboardReducer.showThankYouModal;
}
